<app-nav></app-nav>
<div class="container">
  <div class="advanceViewNotification">
    <div class="notificationBanner">
      <img class="img-resposive" src="{{image}}">
    </div>
    <div class="col-12">
      <div class="row">
        <div class="col-2 goBack">
          <a routerLink="/home"> <i class="fas fa-arrow-left"></i></a>
        </div>
        <div class="col-10">
          <label class="heading">{{title}}</label>
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="row">
        <div class="col text-right margin-sm">
          <span class="date">{{dateCreated | date: 'dd-MMM-yyyy'}}</span>
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="row">
        <div class="col text-center">
          <p class="msg">
            {{message}}
          </p>
        </div>
      </div>
    </div>
  </div>
</div>